import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {SimulationSearch} from "./SimulationSearch";

const vUI_Simulation_Input_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SIMULATION_INPUT_ID:    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Simulation Input Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    SIMULATION_INPUT_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Simulation Input Id',        columnResourceName: 'colSimulationInputId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SIMULATION_INPUT_NAME:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Simulation Input Name',      columnResourceName: 'colSimulationInputName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_SIMULATION_INPUT_ID',
        id_ui: 'SIMULATION_INPUT_ID',
        name:  'SIMULATION_INPUT_NAME'

    },

    searchProviderFields: vUI_Simulation_Input_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Simulation_Input_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SimulationInputSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SimulationInputSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SIMULATION_INPUT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SIMULATION_INPUT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SIMULATION_INPUT_ID', 'SIMULATION_INPUT_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SimulationInputSearch: ISearch = {
    searchName: "Find Simulation Input",
    renderOptions: {ui5ResourceId: "SimulationInputSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SimulationInputSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SimulationInputBO", "SimulationInput", SimulationInputSearch, "Simulation Input Search")

export {SimulationInputSearch}